import React, { useState, useEffect, useRef } from 'react';
import './PromptDialog.css';

const PromptDialog = ({ prompt, onClose }) => {
  const [value, setValue] = useState(prompt.defaultValue || '');
  const inputRef = useRef(null);

  useEffect(() => {
    // Focus automatique sur l'input
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (prompt.required && !value.trim()) {
      return;
    }
    onClose(prompt.id, value);
  };

  const handleCancel = () => {
    onClose(prompt.id, null);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className="prompt-overlay">
      <div className="prompt-dialog">
        <div className="prompt-header">
          <h3 className="prompt-title">{prompt.title || 'Saisir une valeur'}</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="prompt-body">
            {prompt.message && (
              <p className="prompt-message">{prompt.message}</p>
            )}

            {prompt.type === 'textarea' ? (
              <textarea
                ref={inputRef}
                className="prompt-textarea"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={prompt.placeholder || ''}
                rows={4}
              />
            ) : (
              <input
                ref={inputRef}
                type={prompt.inputType || 'text'}
                className="prompt-input"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={prompt.placeholder || ''}
              />
            )}

            {prompt.required && (
              <p className="prompt-hint">Ce champ est requis</p>
            )}
          </div>

          <div className="prompt-footer">
            <button
              type="button"
              className="prompt-button prompt-button-cancel"
              onClick={handleCancel}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="prompt-button prompt-button-confirm"
              disabled={prompt.required && !value.trim()}
            >
              {prompt.confirmText || 'Confirmer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PromptDialog;
